module.exports = __webpack_public_path__ + "assets/img/voice.0f2c493f.png";